// // src/pages/Courses.tsx
// import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
// import { Navigate, useNavigate } from 'react-router-dom';
// import { AuthContext } from '../context/AuthContext';

// import {
//     getCourses,
//     getArchivedCourses,
//     createCourse,
//     updateCourse,
//     deleteCourse,
//     unarchiveCourse,
//     migrateCourseToGroup,
//     getCourse,
//     getMigrationStatus,
// } from '../api/courses';

// import api from '../api/axios';
// import { Course, CreateCourseRequest, UpdateCourseRequest } from '../types/course';
// import CourseForm from '../components/CourseForm';
// import EditCourseForm from '../components/EditCourseForm';
// import Sidebar from '../components/Sidebar';
// import '../styles/Courses.css';

// /* ---------- inline icons (SVG) ---------- */
// const IconBook = () => (
//     <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
//         <path fill="currentColor" d="M19 2H8a3 3 0 0 0-3 3v14a3 3 0 0 1 3-3h11v5H8a1 1 0 0 0 0 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Zm-1 12H8a5.01 5.01 0 0 0-3 1V5a1 1 0 0 1 1-1h12v10Z" />
//     </svg>
// );

// const IconPlus = () => (
//     <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
//         <path fill="currentColor" d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2h6Z" />
//     </svg>
// );

// const IconSearch = () => (
//     <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
//         <path fill="currentColor" d="m21 20-5.6-5.6a7 7 0 1 0-1.4 1.4L20 21l1-1ZM5 10a5 5 0 1 1 10 0A5 5 0 0 1 5 10Z" />
//     </svg>
// );

// const IconEdit = () => (
//     <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
//         <path fill="currentColor" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25Zm18.71-11.04a1.003 1.003 0 0 0 0-1.42l-2.5-2.5a1.003 1.003 0 0 0-1.42 0l-1.83 1.83 3.75 3.75 1.99-1.66Z" />
//     </svg>
// );

// const IconTrash = () => (
//     <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
//         <path fill="currentColor" d="M9 3h6l1 2h4v2H4V5h4l1-2Zm1 7h2v8h-2v-8Zm4 0h2v8h-2v-8ZM6 10h2v8H6v-8Z" />
//     </svg>
// );

// const BadgeOnline = () => (
//     <span className="mode-badge -online">
//     <svg width="10" height="10" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8" fill="currentColor" /></svg>
//     ONLINE
//   </span>
// );

// const BadgePhysical = () => (
//     <span className="mode-badge -physical">
//     <svg width="10" height="10" viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="6" width="12" height="12" rx="2" fill="currentColor" /></svg>
//     PHYSICAL
//   </span>
// );

// export default function Courses() {
//     const { user } = useContext(AuthContext);
//     const navigate = useNavigate();

//     const [loading, setLoading] = useState(true);
//     const [courses, setCourses] = useState<Course[]>([]);
//     const [filtered, setFiltered] = useState<Course[]>([]);
//     const [showArchived, setShowArchived] = useState(false);

//     const [query, setQuery] = useState('');
//     const [showCreate, setShowCreate] = useState(false);
//     const [editTarget, setEditTarget] = useState<Course | null>(null);

//     const [syncLoading, setSyncLoading] = useState<string | null>(null);
//     const [syncAllLoading, setSyncAllLoading] = useState(false);

//     // Group migration state
//     const [migrateTarget, setMigrateTarget] = useState<Course | null>(null);
//     const [migrateGroupEmail, setMigrateGroupEmail] = useState('');
//     const [migrateGroupName, setMigrateGroupName] = useState('');
//     const [migrateLoading, setMigrateLoading] = useState(false);
//     const [migratingCourseIds, setMigratingCourseIds] = useState<Set<string>>(new Set());

//     // Migration log modal
//     const [logTarget, setLogTarget] = useState<Course | null>(null);
//     const pollRef = useRef<ReturnType<typeof setInterval> | null>(null);

//     const role = user?.role ?? 'viewer';
//     const canModify = role !== 'viewer';

//     useEffect(() => {
//         if (!user) return;
//         setLoading(true);
//         const loader = showArchived ? getArchivedCourses : getCourses;
//         loader()
//             .then((data) => {
//                 setCourses(data);
//             })
//             .finally(() => setLoading(false));
//     }, [showArchived, user]);

//     // search
//     useEffect(() => {
//         const q = query.trim().toLowerCase();
//         setFiltered(
//             q === ''
//                 ? courses
//                 : courses.filter(
//                     (c) =>
//                         c.name.toLowerCase().includes(q) ||
//                         (c.description || '').toLowerCase().includes(q),
//                 ),
//         );
//     }, [courses, query]);

//     const activeCount = useMemo(() => courses.length, [courses]);

//     // Poll migration status every 3 s while the log modal is open and migration is running
//     useEffect(() => {
//         if (!logTarget || logTarget.groupMigrationStatus !== 'migrating') return;

//         const tick = async () => {
//             try {
//                 const status = await getMigrationStatus(logTarget.id);
//                 setLogTarget(prev => prev ? { ...prev, ...status } : prev);
//                 setCourses(prev => prev.map(c => c.id === logTarget.id ? { ...c, ...status } : c));
//                 if (status.groupMigrationStatus !== 'migrating') {
//                     if (pollRef.current) clearInterval(pollRef.current);
//                     pollRef.current = null;
//                 }
//             } catch { /* ignore transient errors */ }
//         };

//         pollRef.current = setInterval(tick, 3000);
//         return () => { if (pollRef.current) clearInterval(pollRef.current); };
//     }, [logTarget?.id, logTarget?.groupMigrationStatus]);

//     if (!user) return <Navigate to="/" replace />;

//     const handleCreate = async (body: CreateCourseRequest) => {
//         const c = await createCourse(body);
//         setCourses((prev) => [c, ...prev]);
//         setShowCreate(false);
//     };

//     const handleUpdate = async (id: string, body: UpdateCourseRequest) => {
//         const c = await updateCourse(id, body);
//         setCourses((prev) => prev.map((x) => (x.id === id ? c : x)));
//         setEditTarget(null);
//     };

//     const handleArchive = async (id: string) => {
//         if (!window.confirm('Move to Recycle Bin?')) return;
//         await deleteCourse(id);
//         setCourses((prev) => prev.filter((x) => x.id !== id));
//     };

//     const handleUnarchive = async (id: string) => {
//         if (!window.confirm('Restore from Recycle Bin?')) return;
//         await unarchiveCourse(id);
//         setCourses((prev) => prev.filter((x) => x.id !== id));
//     };

//     const handleSyncDrive = async (courseId: string, driveFolderId: string) => {
//         if (!window.confirm('Sync drive folder now?')) return;
//         setSyncLoading(courseId);
//         try {
//             await api.post('/courses/sync-drive', { courseId, driveFolderId });
//             alert('Drive sync completed.');
//         } catch (e: any) {
//             alert(e?.response?.data?.message || 'Sync failed.');
//         } finally {
//             setSyncLoading(null);
//         }
//     };

//     const handleSyncAll = async () => {
//         const list = courses.filter((c) => !!c.driveFolderId);
//         if (list.length === 0) return alert('No courses with drive folders.');
//         if (!window.confirm(`Sync ${list.length} courses?`)) return;

//         setSyncAllLoading(true);
//         try {
//             for (const c of list) {
//                 await api.post('/courses/sync-drive', {
//                     courseId: c.id,
//                     driveFolderId: c.driveFolderId!,
//                 });
//             }
//             alert('Sync all completed.');
//         } finally {
//             setSyncAllLoading(false);
//         }
//     };

//     const handleMigrateOpen = (c: Course) => {
//         setMigrateTarget(c);
//         setMigrateGroupEmail('');
//         setMigrateGroupName(`${c.name} Access Group`);
//     };

//     const handleMigrateSubmit = async () => {
//         if (!migrateTarget) return;
//         if (!migrateGroupEmail.trim()) return alert('Group email is required.');
//         setMigrateLoading(true);
//         try {
//             await migrateCourseToGroup(migrateTarget.id, migrateGroupEmail.trim(), migrateGroupName.trim() || undefined);
//             // Optimistically mark as migrating in local state
//             setCourses(prev => prev.map(c =>
//                 c.id === migrateTarget.id
//                     ? { ...c, driveGroupEmail: migrateGroupEmail.trim(), groupMigrationStatus: 'migrating' }
//                     : c
//             ));
//             setMigratingCourseIds(prev => new Set([...prev, migrateTarget.id]));
//             setMigrateTarget(null);
//             alert(`Migration started for "${migrateTarget.name}". Students are being moved to the group in the background.`);
//         } catch (e: any) {
//             alert(e?.response?.data?.message || 'Migration failed.');
//         } finally {
//             setMigrateLoading(false);
//         }
//     };

//     const openLogModal = (c: Course) => {
//         setLogTarget(c);
//     };

//     const closeLogModal = () => {
//         if (pollRef.current) clearInterval(pollRef.current);
//         pollRef.current = null;
//         setLogTarget(null);
//     };

//     return (
//         <div className="courses-page">
//             <Sidebar />

//             <main className="courses-content">
//                 {/* title & sub */}
//                 <div className="page-title">
//                     <div className="title-left">
//                         <span className="title-icon"><IconBook /></span>
//                         <h1>Courses</h1>
//                     </div>
//                     {!showArchived && canModify && (
//                         <button className="btn-primary new-btn" onClick={() => setShowCreate(true)}>
//                             <IconPlus /> New Course
//                         </button>
//                     )}
//                 </div>
//                 <p className="page-sub">Manage courses and their configurations</p>

//                 {/* filter/search bar */}
//                 <div className="toolbar">
//                     <div className="state-toggle">
//                         <span className={`state-label ${!showArchived ? 'active' : ''}`}>Course State: Active</span>
//                         <label className="switch">
//                             <input
//                                 type="checkbox"
//                                 checked={showArchived}
//                                 onChange={() => setShowArchived((v) => !v)}
//                             />
//                             <span className="slider" />
//                         </label>
//                         <span className={`state-label ${showArchived ? 'active' : ''}`}>Recycle Bin</span>
//                     </div>

//                     <div className="search">
//                         <span className="search-icon"><IconSearch /></span>
//                         <input
//                             className="search-input"
//                             placeholder="Search courses..."
//                             value={query}
//                             onChange={(e) => setQuery(e.target.value)}
//                         />
//                     </div>

//                     {!showArchived && canModify && (
//                         <button
//                             className="btn-secondary sync-btn"
//                             onClick={handleSyncAll}
//                             disabled={syncAllLoading || loading}
//                             title="Sync all courses with drive folders"
//                         >
//                             {syncAllLoading ? (
//                                 <span className="spinner" aria-hidden />
//                             ) : (
//                                 <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
//                                     <path fill="currentColor" d="M12 6V3L8 7l4 4V8a4 4 0 1 1-4 4H6a6 6 0 1 0 6-6Z" />
//                                 </svg>
//                             )}
//                             Sync All
//                         </button>
//                     )}
//                 </div>

//                 {/* cards/grid */}
//                 {loading ? (
//                     <div className="loading">Loading…</div>
//                 ) : filtered.length === 0 ? (
//                     <div className="empty">No {showArchived ? 'archived ' : ''}courses.</div>
//                 ) : (
//                     <div className="cards-grid">
//                         {filtered.map((c) => {
//                             const mode =
//                                 (c as any).deliveryMode?.toLowerCase() ||
//                                 ((c as any).isOnline ? 'online' : 'physical');

//                             return (
//                                 <article className="course-card" key={c.id}>
//                                     <header className="card-head">
//                                         <div>
//                                             <h2 className="course-title">{c.name}</h2>
//                                             {mode === 'online' ? <BadgeOnline /> : <BadgePhysical />}
//                                             <p className="course-desc">{c.description || '—'}</p>
//                                         </div>
//                                     </header>

//                                     <div className="details-grid">
//                                         <div className="detail">
//                                             <div className="label">Base Fee</div>
//                                             <div className="value">₹{Number(c.baseFee).toLocaleString('en-IN')}</div>
//                                         </div>
//                                         <div className="detail">
//                                             <div className="label">Period</div>
//                                             <div className="value">{c.periodMonths} {Number(c.periodMonths) === 1 ? 'day' : 'days'}</div>
//                                         </div>
//                                         <div className="detail">
//                                             <div className="label">Material Access</div>
//                                             <div className="value">{c.materialAccessPeriod} {Number(c.materialAccessPeriod) === 1 ? 'day' : 'days'}</div>
//                                         </div>
//                                         <div className="detail">
//                                             <div className="label">Max Viewer Discount</div>
//                                             <div className="value">₹{Number(c.maxViewerDiscount || 0).toLocaleString('en-IN')}</div>
//                                         </div>
//                                     </div>

//                                     <div className="kv">
//                                         <div className="kv-label">Telegram Server ID</div>
//                                         <div className="kv-box">{c.telegramServerId || '—'}</div>
//                                     </div>

//                                     {(c as any).driveFolderUrl && (
//                                         <div className="kv">
//                                             <div className="kv-label">Google Drive Folder</div>
//                                             <a
//                                                 className="drive-link"
//                                                 href={(c as any).driveFolderUrl}
//                                                 target="_blank"
//                                                 rel="noreferrer"
//                                             >
//                                                 {(c as any).driveFolderUrl}
//                                             </a>
//                                         </div>
//                                     )}

//                                     {c.driveGroupEmail && (
//                                         <div className="kv">
//                                             <div className="kv-label">Drive Access Group</div>
//                                             <div className="kv-box group-kv">
//                                                 <span className={`group-status-badge -${c.groupMigrationStatus || 'none'}`}>
//                                                     {c.groupMigrationStatus === 'completed' ? 'GROUP ACTIVE' :
//                                                      c.groupMigrationStatus === 'migrating' ? 'MIGRATING…' :
//                                                      c.groupMigrationStatus === 'failed' ? 'FAILED' : 'GROUP'}
//                                                 </span>
//                                                 <span className="group-email" title={c.driveGroupEmail}>{c.driveGroupEmail}</span>
//                                             </div>
//                                         </div>
//                                     )}

//                                     <footer className="card-foot">
//                                         {canModify && !showArchived ? (
//                                             <>
//                                                 <button
//                                                     className="btn-outline"
//                                                     onClick={() => navigate(`/courses/${c.id}/mobile-delivery`)}
//                                                     title="Manage mobile delivery policy and migration"
//                                                 >
//                                                     Mobile Delivery
//                                                 </button>
//                                                 <button
//                                                     className="btn-outline"
//                                                     onClick={() => navigate(`/courses/${c.id}/materials`)}
//                                                     title="Synchronize and publish mobile materials"
//                                                 >
//                                                     Materials
//                                                 </button>
//                                                 <button
//                                                     className="btn-outline"
//                                                     onClick={() => navigate(`/courses/${c.id}/offline-downloads`)}
//                                                     title="Configure offline downloads and inspect grants"
//                                                 >
//                                                     Offline Downloads
//                                                 </button>
//                                                 <button
//                                                     className="btn-ghost"
//                                                     onClick={() => setEditTarget(c)}
//                                                     title="Edit"
//                                                 >
//                                                     <IconEdit /> Edit
//                                                 </button>
//                                                 <button
//                                                     className="btn-danger"
//                                                     onClick={() => handleArchive(c.id)}
//                                                     title="Move to Recycle Bin"
//                                                 >
//                                                     <IconTrash /> Move to Recycle Bin
//                                                 </button>

//                                                 {c.driveFolderId && (
//                                                     <button
//                                                         className="btn-outline"
//                                                         onClick={() => handleSyncDrive(c.id, c.driveFolderId!)}
//                                                         disabled={syncLoading === c.id}
//                                                         title="Sync drive"
//                                                     >
//                                                         {syncLoading === c.id ? (
//                                                             <span className="spinner" aria-hidden />
//                                                         ) : (
//                                                             <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
//                                                                 <path fill="currentColor" d="M12 6V3L8 7l4 4V8a4 4 0 1 1-4 4H6a6 6 0 1 0 6-6Z" />
//                                                             </svg>
//                                                         )}
//                                                         Sync Drive
//                                                     </button>
//                                                 )}

//                                                 {c.driveFolderId && !c.isMigratedToGroup && c.groupMigrationStatus !== 'migrating' && (
//                                                     <button
//                                                         className="btn-migrate"
//                                                         onClick={() => handleMigrateOpen(c)}
//                                                         title="Migrate individual permissions to a Google Group"
//                                                     >
//                                                         <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
//                                                             <path fill="currentColor" d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
//                                                         </svg>
//                                                         Migrate to Group
//                                                     </button>
//                                                 )}

//                                                 {c.groupMigrationStatus === 'migrating' && (
//                                                     <>
//                                                         <button
//                                                             className="btn-migrate -migrating"
//                                                             onClick={() => openLogModal(c)}
//                                                             title="View live migration progress"
//                                                         >
//                                                             <span className="spinner" aria-hidden />
//                                                             View Progress
//                                                         </button>
//                                                         <button
//                                                             className="btn-migrate -failed"
//                                                             onClick={() => handleMigrateOpen(c)}
//                                                             title="Re-run migration (safe to repeat)"
//                                                         >
//                                                             Re-run
//                                                         </button>
//                                                     </>
//                                                 )}

//                                                 {(c.groupMigrationStatus === 'completed' || c.groupMigrationStatus === 'failed') && c.driveGroupEmail && (
//                                                     <>
//                                                         <button
//                                                             className="btn-migrate"
//                                                             onClick={() => openLogModal(c)}
//                                                             title="View migration log"
//                                                         >
//                                                             View Log
//                                                         </button>
//                                                         <button
//                                                             className="btn-migrate -failed"
//                                                             onClick={() => handleMigrateOpen(c)}
//                                                             title="Re-run migration to a different or same group"
//                                                         >
//                                                             Re-migrate
//                                                         </button>
//                                                     </>
//                                                 )}

//                                                 {c.groupMigrationStatus === 'failed' && (
//                                                     <button
//                                                         className="btn-migrate -failed"
//                                                         onClick={() => handleMigrateOpen(c)}
//                                                         title="Retry migration"
//                                                     >
//                                                         Retry
//                                                     </button>
//                                                 )}
//                                             </>
//                                         ) : canModify && showArchived ? (
//                                             <button className="btn-primary" onClick={() => handleUnarchive(c.id)}>
//                                                 Restore
//                                             </button>
//                                         ) : null}
//                                     </footer>
//                                 </article>
//                             );
//                         })}
//                     </div>
//                 )}

//                 {!showArchived && showCreate && (
//                     <CourseForm onSubmit={handleCreate} onCancel={() => setShowCreate(false)} />
//                 )}
//                 {!!editTarget && (
//                     <EditCourseForm
//                         course={editTarget}
//                         onSubmit={handleUpdate}
//                         onCancel={() => setEditTarget(null)}
//                     />
//                 )}

//                 {!!logTarget && (() => {
//                     const s = logTarget.groupMigrationStats;
//                     const total    = s?.total    ?? 0;
//                     const migrated = s?.migrated ?? 0;
//                     const failed   = s?.failed   ?? 0;
//                     const pct      = total > 0 ? Math.round((migrated / total) * 100) : 0;
//                     const isLive   = logTarget.groupMigrationStatus === 'migrating';
//                     return (
//                         <div className="migrate-overlay" onClick={closeLogModal}>
//                             <div className="migrate-modal log-modal" onClick={e => e.stopPropagation()}>
//                                 <div className="log-header">
//                                     <h2 className="migrate-title">Migration Log</h2>
//                                     <span className={`group-status-badge -${logTarget.groupMigrationStatus || 'none'}`}>
//                                         {logTarget.groupMigrationStatus === 'completed' ? 'COMPLETED' :
//                                          logTarget.groupMigrationStatus === 'migrating'  ? 'IN PROGRESS' :
//                                          logTarget.groupMigrationStatus === 'failed'     ? 'FAILED' : '—'}
//                                     </span>
//                                 </div>

//                                 <p className="migrate-desc">
//                                     <strong>{logTarget.name}</strong><br />
//                                     Group: <code className="log-code">{logTarget.driveGroupEmail}</code>
//                                 </p>

//                                 {/* Progress bar */}
//                                 {total > 0 && (
//                                     <div className="log-progress-wrap">
//                                         <div className="log-progress-bar">
//                                             <div className="log-progress-fill" style={{ width: `${pct}%` }} />
//                                         </div>
//                                         <span className="log-progress-label">{migrated} / {total} students ({pct}%)</span>
//                                     </div>
//                                 )}

//                                 {/* Stats grid */}
//                                 <div className="log-stats">
//                                     <div className="log-stat">
//                                         <div className="log-stat-val -green">{migrated}</div>
//                                         <div className="log-stat-key">Migrated</div>
//                                     </div>
//                                     <div className="log-stat">
//                                         <div className="log-stat-val -red">{failed}</div>
//                                         <div className="log-stat-key">Failed</div>
//                                     </div>
//                                     <div className="log-stat">
//                                         <div className="log-stat-val">{total - migrated - failed}</div>
//                                         <div className="log-stat-key">Pending</div>
//                                     </div>
//                                     <div className="log-stat">
//                                         <div className="log-stat-val">{total}</div>
//                                         <div className="log-stat-key">Total</div>
//                                     </div>
//                                 </div>

//                                 {/* Timestamps */}
//                                 <div className="log-times">
//                                     {s?.startedAt   && <span>Started: {new Date(s.startedAt).toLocaleString()}</span>}
//                                     {s?.completedAt  && <span>Completed: {new Date(s.completedAt).toLocaleString()}</span>}
//                                     {isLive && <span className="log-live"><span className="spinner" aria-hidden /> Live — refreshing every 3 s</span>}
//                                 </div>

//                                 {/* Failed emails */}
//                                 {(s?.failedEmails?.length ?? 0) > 0 && (
//                                     <div className="log-failures">
//                                         <div className="log-failures-title">Failed emails</div>
//                                         <ul className="log-failures-list">
//                                             {s!.failedEmails.map(email => (
//                                                 <li key={email}>{email}</li>
//                                             ))}
//                                         </ul>
//                                     </div>
//                                 )}

//                                 <div className="migrate-actions">
//                                     <button className="btn-ghost" onClick={closeLogModal}>Close</button>
//                                 </div>
//                             </div>
//                         </div>
//                     );
//                 })()}

//                 {!!migrateTarget && (
//                     <div className="migrate-overlay">
//                         <div className="migrate-modal">
//                             <h2 className="migrate-title">Migrate to Google Group</h2>
//                             <p className="migrate-desc">
//                                 Course: <strong>{migrateTarget.name}</strong><br />
//                                 All students currently sharing the Drive folder will be moved to a Google Group.
//                                 Existing access is uninterrupted — students won't notice the switch.
//                             </p>

//                             <label className="migrate-label">
//                                 Group Email <span className="migrate-required">*</span>
//                                 <input
//                                     className="migrate-input"
//                                     type="email"
//                                     placeholder="e.g. physics-2024@yourdomain.com"
//                                     value={migrateGroupEmail}
//                                     onChange={e => setMigrateGroupEmail(e.target.value)}
//                                     autoFocus
//                                 />
//                                 <span className="migrate-hint">Must be a valid Google Workspace group email on your domain.</span>
//                             </label>

//                             <label className="migrate-label">
//                                 Group Name <span className="migrate-optional">(optional)</span>
//                                 <input
//                                     className="migrate-input"
//                                     type="text"
//                                     placeholder="Display name for the group"
//                                     value={migrateGroupName}
//                                     onChange={e => setMigrateGroupName(e.target.value)}
//                                 />
//                             </label>

//                             <div className="migrate-actions">
//                                 <button
//                                     className="btn-primary"
//                                     onClick={handleMigrateSubmit}
//                                     disabled={migrateLoading || !migrateGroupEmail.trim()}
//                                 >
//                                     {migrateLoading ? <span className="spinner" aria-hidden /> : null}
//                                     {migrateLoading ? 'Starting…' : 'Migrate'}
//                                 </button>
//                                 <button
//                                     className="btn-ghost"
//                                     onClick={() => setMigrateTarget(null)}
//                                     disabled={migrateLoading}
//                                 >
//                                     Cancel
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 )}
//             </main>
//         </div>
//     );
// }

// src/pages/Courses.tsx

import React, { useContext, useEffect, useRef, useState } from "react";

import { Navigate, useNavigate } from "react-router-dom";

import { AuthContext } from "../context/AuthContext";

import {
  getCourses,
  getArchivedCourses,
  createCourse,
  updateCourse,
  deleteCourse,
  unarchiveCourse,
  migrateCourseToGroup,
  getMigrationStatus,
} from "../api/courses";

import api from "../api/axios";

import {
  Course,
  CreateCourseRequest,
  UpdateCourseRequest,
} from "../types/course";

import CourseForm from "../components/CourseForm";
import EditCourseForm from "../components/EditCourseForm";
import Sidebar from "../components/Sidebar";
import CourseMaterialSyncDialog from "../features/mobileAdmin/materials/CourseMaterialSyncDialog";
import BulkCourseMaterialSyncDialog from "../features/mobileAdmin/materials/BulkCourseMaterialSyncDialog";
import { accessUnitLabel } from "../utils/timerMode";

/* =========================================================
   ICONS
========================================================= */

const IconBook = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M19 2H8a3 3 0 0 0-3 3v14a3 3 0 0 1 3-3h11v5H8a1 1 0 0 0 0 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Zm-1 12H8a5.01 5.01 0 0 0-3 1V5a1 1 0 0 1 1-1h12v10Z"
    />
  </svg>
);

const IconPlus = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
    <path fill="currentColor" d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2h6Z" />
  </svg>
);

const IconSearch = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="m21 20-5.6-5.6a7 7 0 1 0-1.4 1.4L20 21l1-1ZM5 10a5 5 0 1 1 10 0A5 5 0 0 1 5 10Z"
    />
  </svg>
);

const IconEdit = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25Zm18.71-11.04a1.003 1.003 0 0 0 0-1.42l-2.5-2.5a1.003 1.003 0 0 0-1.42 0l-1.83 1.83 3.75 3.75 1.99-1.66Z"
    />
  </svg>
);

const IconTrash = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M9 3h6l1 2h4v2H4V5h4l1-2Zm1 7h2v8h-2v-8Zm4 0h2v8h-2v-8ZM6 10h2v8H6v-8Z"
    />
  </svg>
);

const IconMore = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="5" cy="12" r="1.8" fill="currentColor" />
    <circle cx="12" cy="12" r="1.8" fill="currentColor" />
    <circle cx="19" cy="12" r="1.8" fill="currentColor" />
  </svg>
);

const IconSync = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M12 6V3L8 7l4 4V8a4 4 0 1 1-4 4H6a6 6 0 1 0 6-6Z"
    />
  </svg>
);

const IconUsers = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3Zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3Zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5C15 14.17 10.33 13 8 13Zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5Z"
    />
  </svg>
);

const IconPhone = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <rect
      x="7"
      y="2.5"
      width="10"
      height="19"
      rx="2"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <circle cx="12" cy="18" r="1" fill="currentColor" />
  </svg>
);

const IconFolder = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M3 6.5A2.5 2.5 0 0 1 5.5 4H10l2 2h6.5A2.5 2.5 0 0 1 21 8.5v8A2.5 2.5 0 0 1 18.5 19h-13A2.5 2.5 0 0 1 3 16.5v-10Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
  </svg>
);

const IconDownload = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M12 3v11m0 0 4-4m-4 4-4-4"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M5 17v2a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-2"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

/* =========================================================
   SMALL UI HELPERS
========================================================= */

const Spinner = ({ dark = false }: { dark?: boolean }) => (
  <span
    className={[
      "inline-block h-4 w-4 animate-spin rounded-full border-2",
      dark
        ? "border-white/40 border-t-white"
        : "border-slate-300 border-t-slate-700",
    ].join(" ")}
    aria-hidden
  />
);

const DeliveryBadge = ({ mode }: { mode: string }) => {
  const isOnline = mode === "online";

  return (
    <span
      className={[
        "inline-flex h-7 items-center rounded-full px-3",
        "text-[11px] font-medium uppercase tracking-[0.01em]",
        isOnline
          ? "bg-emerald-50 text-emerald-700"
          : "bg-amber-100 text-amber-700",
      ].join(" ")}
    >
      {isOnline ? "Online" : "Physical"}
    </span>
  );
};

const GroupStatusBadge = ({ status }: { status?: string }) => {
  let classes = "bg-slate-100 text-slate-600";

  let label = "GROUP";

  if (status === "completed") {
    classes = "bg-emerald-50 text-emerald-700";
    label = "GROUP ACTIVE";
  }

  if (status === "migrating") {
    classes = "bg-blue-50 text-blue-700";
    label = "MIGRATING…";
  }

  if (status === "failed") {
    classes = "bg-red-50 text-red-700";
    label = "FAILED";
  }

  return (
    <span
      className={[
        "inline-flex shrink-0 items-center rounded-full",
        "px-2.5 py-1 text-[10px] font-bold",
        classes,
      ].join(" ")}
    >
      {label}
    </span>
  );
};

/* =========================================================
   PAGE
========================================================= */

export default function Courses() {
  const { user } = useContext(AuthContext);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  const [courses, setCourses] = useState<Course[]>([]);
  const [filtered, setFiltered] = useState<Course[]>([]);

  const [showArchived, setShowArchived] = useState(false);

  const [query, setQuery] = useState("");

  const [showCreate, setShowCreate] = useState(false);

  const [editTarget, setEditTarget] = useState<Course | null>(null);

  const [materialSyncTarget, setMaterialSyncTarget] = useState<Course | null>(null);

  const [syncLoading, setSyncLoading] = useState<string | null>(null);

  const [syncAllLoading, setSyncAllLoading] = useState(false);

  const [bulkMaterialSyncCourses, setBulkMaterialSyncCourses] = useState<Course[] | null>(null);

  /*
   * Overflow menu
   */
  const [openMenuId, setOpenMenuId] = useState<string | null>(null);

  /*
   * Group migration
   */
  const [migrateTarget, setMigrateTarget] = useState<Course | null>(null);

  const [migrateGroupEmail, setMigrateGroupEmail] = useState("");

  const [migrateGroupName, setMigrateGroupName] = useState("");

  const [migrateLoading, setMigrateLoading] = useState(false);

  /*
   * Migration log
   */
  const [logTarget, setLogTarget] = useState<Course | null>(null);

  const pollRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const role = user?.role ?? "viewer";

  const canModify = role !== "viewer";

  /* =======================================================
     LOAD COURSES
  ======================================================= */

  useEffect(() => {
    if (!user) return;

    setLoading(true);

    const loader = showArchived ? getArchivedCourses : getCourses;

    loader()
      .then((data) => {
        setCourses(data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [showArchived, user]);

  /* =======================================================
     SEARCH
  ======================================================= */

  useEffect(() => {
    const q = query.trim().toLowerCase();

    if (!q) {
      setFiltered(courses);
      return;
    }

    setFiltered(
      courses.filter((course) => {
        return (
          course.name.toLowerCase().includes(q) ||
          (course.description || "").toLowerCase().includes(q)
        );
      }),
    );
  }, [courses, query]);

  /* =======================================================
     CLOSE OVERFLOW MENU WHEN CLICKING OUTSIDE
  ======================================================= */

  useEffect(() => {
    const closeMenu = () => {
      setOpenMenuId(null);
    };

    document.addEventListener("click", closeMenu);

    return () => {
      document.removeEventListener("click", closeMenu);
    };
  }, []);

  /* =======================================================
     POLL MIGRATION STATUS
  ======================================================= */

  useEffect(() => {
    if (!logTarget || logTarget.groupMigrationStatus !== "migrating") {
      return;
    }

    const tick = async () => {
      try {
        const status = await getMigrationStatus(logTarget.id);

        setLogTarget((prev) =>
          prev
            ? {
                ...prev,
                ...status,
              }
            : prev,
        );

        setCourses((prev) =>
          prev.map((course) =>
            course.id === logTarget.id
              ? {
                  ...course,
                  ...status,
                }
              : course,
          ),
        );

        if (status.groupMigrationStatus !== "migrating") {
          if (pollRef.current) {
            clearInterval(pollRef.current);
          }

          pollRef.current = null;
        }
      } catch {
        /*
         * Ignore transient polling errors.
         */
      }
    };

    pollRef.current = setInterval(tick, 3000);

    return () => {
      if (pollRef.current) {
        clearInterval(pollRef.current);
      }
    };
  }, [logTarget?.id, logTarget?.groupMigrationStatus]);

  if (!user) {
    return <Navigate to="/" replace />;
  }

  /* =======================================================
     CREATE
  ======================================================= */

  const handleCreate = async (body: CreateCourseRequest) => {
    const created = await createCourse(body);

    setCourses((prev) => [created, ...prev]);

    setShowCreate(false);
  };

  /* =======================================================
     UPDATE
  ======================================================= */

  const handleUpdate = async (id: string, body: UpdateCourseRequest) => {
    const updated = await updateCourse(id, body);

    setCourses((prev) =>
      prev.map((course) => (course.id === id ? updated : course)),
    );

    setEditTarget(null);
  };

  /* =======================================================
     ARCHIVE
  ======================================================= */

  const handleArchive = async (id: string) => {
    if (!window.confirm("Move to Recycle Bin?")) {
      return;
    }

    await deleteCourse(id);

    setCourses((prev) => prev.filter((course) => course.id !== id));
  };

  /* =======================================================
     RESTORE
  ======================================================= */

  const handleUnarchive = async (id: string) => {
    if (!window.confirm("Restore from Recycle Bin?")) {
      return;
    }

    await unarchiveCourse(id);

    setCourses((prev) => prev.filter((course) => course.id !== id));
  };

  /* =======================================================
     SYNC DRIVE
  ======================================================= */

  const handleSyncDrive = async (courseId: string, driveFolderId: string) => {
    if (!window.confirm("Sync drive folder now?")) {
      return;
    }

    setSyncLoading(courseId);

    try {
      await api.post("/courses/sync-drive", {
        courseId,
        driveFolderId,
      });

      alert("Drive sync completed.");
    } catch (e: any) {
      alert(e?.response?.data?.message || "Sync failed.");
    } finally {
      setSyncLoading(null);
    }
  };

  /* =======================================================
     SYNC ALL
  ======================================================= */

  const handleSyncAll = async () => {
    const list = courses.filter((course) => !!course.driveFolderId);

    if (list.length === 0) {
      alert("No courses with drive folders.");

      return;
    }

    if (!window.confirm(`Sync ${list.length} courses?`)) {
      return;
    }

    setSyncAllLoading(true);

    try {
      for (const course of list) {
        await api.post("/courses/sync-drive", {
          courseId: course.id,

          driveFolderId: course.driveFolderId!,
        });
      }

      alert("Sync all completed.");
    } finally {
      setSyncAllLoading(false);
    }
  };

  const handleSyncAllMaterials = () => {
    const eligible = courses.filter((course) => !!course.driveFolderId);

    if (eligible.length === 0) {
      alert("No courses with Drive folders were found.");
      return;
    }

    if (
      !window.confirm(
        `Synchronize Drive and mobile materials for all ${eligible.length} courses?`,
      )
    ) {
      return;
    }

    setBulkMaterialSyncCourses(eligible);
  };

  /* =======================================================
     MIGRATION OPEN
  ======================================================= */

  const handleMigrateOpen = (course: Course) => {
    setMigrateTarget(course);

    setMigrateGroupEmail("");

    setMigrateGroupName(`${course.name} Access Group`);
  };

  /* =======================================================
     MIGRATION SUBMIT
  ======================================================= */

  const handleMigrateSubmit = async () => {
    if (!migrateTarget) {
      return;
    }

    if (!migrateGroupEmail.trim()) {
      alert("Group email is required.");

      return;
    }

    setMigrateLoading(true);

    try {
      await migrateCourseToGroup(
        migrateTarget.id,
        migrateGroupEmail.trim(),
        migrateGroupName.trim() || undefined,
      );

      setCourses((prev) =>
        prev.map((course) =>
          course.id === migrateTarget.id
            ? {
                ...course,

                driveGroupEmail: migrateGroupEmail.trim(),

                groupMigrationStatus: "migrating",
              }
            : course,
        ),
      );

      setMigrateTarget(null);

      alert(
        `Migration started for "${migrateTarget.name}". Students are being moved to the group in the background.`,
      );
    } catch (e: any) {
      alert(e?.response?.data?.message || "Migration failed.");
    } finally {
      setMigrateLoading(false);
    }
  };

  const openLogModal = (course: Course) => {
    setLogTarget(course);
  };

  const closeLogModal = () => {
    if (pollRef.current) {
      clearInterval(pollRef.current);
    }

    pollRef.current = null;

    setLogTarget(null);
  };

  /* =======================================================
     RENDER
  ======================================================= */

  return (
    <div className="flex min-h-screen bg-[#f7f8fb]">
      <Sidebar />

      <main
        className="
          min-w-0 flex-1
          ml-[280px]
          px-6 py-6
          max-lg:ml-0
          max-lg:px-4
          max-sm:px-3
        "
      >
        {/* =================================================
            PAGE HEADER
        ================================================= */}

        <div
          className="
            mb-1
            flex items-center
            justify-between
            gap-4
          "
        >
          <div
            className="
              flex items-center gap-3
            "
          >
            <div
              className="
                grid h-10 w-10
                place-items-center
                rounded-xl
                border border-slate-200
                bg-white
                text-slate-700
                shadow-sm
              "
            >
              <IconBook />
            </div>

            <h1
              className="
                m-0
                text-[27px]
                font-bold
                tracking-[-0.025em]
                text-slate-950
              "
            >
              Courses
            </h1>
          </div>

          {!showArchived && canModify && (
            <button
              type="button"
              onClick={handleSyncAllMaterials}
              disabled={Boolean(bulkMaterialSyncCourses) || loading}
              className="
                  inline-flex h-10
                  items-center
                  justify-center
                  gap-2
                  rounded-xl
                  border
                  border-slate-200
                  bg-white
                  px-4
                  text-sm
                  font-semibold
                  text-slate-700
                  shadow-sm
                  transition
                  hover:bg-slate-50
                  disabled:cursor-not-allowed
                  disabled:opacity-50
                "
            >
              {bulkMaterialSyncCourses ? <Spinner /> : <IconSync />}
              Sync Materials
            </button>
          )}

          {!showArchived && canModify && (
            <button
              type="button"
              onClick={() => setShowCreate(true)}
              className="
                  inline-flex h-10
                  items-center
                  justify-center
                  gap-2
                  rounded-xl
                  border-0
                  bg-slate-950
                  px-4
                  text-sm
                  font-semibold
                  text-white
                  shadow-sm
                  transition
                  hover:bg-slate-800
                  disabled:cursor-not-allowed
                  disabled:opacity-60
                "
            >
              <IconPlus />
              New Course
            </button>
          )}
        </div>

        <p
          className="
            mb-5 mt-1
            text-sm
            text-slate-500
          "
        >
          Manage courses and their configurations
        </p>

        {/* =================================================
            TOOLBAR
        ================================================= */}

        <div
          className="
            mb-6
            flex
            flex-wrap
            items-center
            gap-3
            rounded-2xl
            border
            border-slate-200
            bg-white
            p-3
            shadow-[0_1px_3px_rgba(15,23,42,0.05)]
          "
        >
          {/* State selector */}

          <div
            className="
              flex
              min-h-10
              items-center
              gap-2
              px-1
            "
          >
            <span
              className={[
                "whitespace-nowrap text-sm font-semibold",
                !showArchived ? "text-slate-950" : "text-slate-500",
              ].join(" ")}
            >
              Course State: Active
            </span>

            <label
              className="
                relative
                inline-flex
                h-6 w-11
                cursor-pointer
                items-center
              "
            >
              <input
                type="checkbox"
                checked={showArchived}
                onChange={() => setShowArchived((prev) => !prev)}
                className="peer sr-only"
              />

              <span
                className="
                  absolute inset-0
                  rounded-full
                  bg-slate-200
                  transition
                  peer-checked:bg-slate-700
                "
              />

              <span
                className="
                  absolute
                  left-[3px]
                  top-[3px]
                  h-[18px]
                  w-[18px]
                  rounded-full
                  bg-white
                  shadow-sm
                  transition-transform
                  peer-checked:translate-x-5
                "
              />
            </label>

            <span
              className={[
                "whitespace-nowrap text-sm font-semibold",
                showArchived ? "text-slate-950" : "text-slate-500",
              ].join(" ")}
            >
              Recycle Bin
            </span>
          </div>

          {/* Search */}

          <div
            className="
              relative
              min-w-[220px]
              flex-1
            "
          >
            <span
              className="
                pointer-events-none
                absolute
                left-3
                top-1/2
                -translate-y-1/2
                text-slate-400
              "
            >
              <IconSearch />
            </span>

            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search courses..."
              className="
                h-10 w-full
                box-border
                rounded-xl
                border
                border-slate-200
                bg-white
                py-0
                pl-10
                pr-3
                text-sm
                text-slate-900
                outline-none
                transition
                placeholder:text-slate-400
                focus:border-slate-400
                focus:ring-2
                focus:ring-slate-100
              "
            />
          </div>

          {!showArchived && canModify && (
            <button
              type="button"
              onClick={handleSyncAll}
              disabled={syncAllLoading || loading}
              className="
                  inline-flex h-10
                  items-center
                  justify-center
                  gap-2
                  rounded-xl
                  border
                  border-slate-200
                  bg-white
                  px-4
                  text-sm
                  font-semibold
                  text-slate-700
                  shadow-sm
                  transition
                  hover:bg-slate-50
                  disabled:cursor-not-allowed
                  disabled:opacity-50
                "
            >
              {syncAllLoading ? <Spinner /> : <IconSync />}
              Sync All
            </button>
          )}
        </div>

        {/* =================================================
            LOADING
        ================================================= */}

        {loading ? (
          <div
            className="
              py-16
              text-center
              text-sm
              text-slate-500
            "
          >
            Loading…
          </div>
        ) : filtered.length === 0 ? (
          <div
            className="
              rounded-2xl
              border
              border-dashed
              border-slate-300
              bg-white
              px-6 py-16
              text-center
              text-sm
              text-slate-500
            "
          >
            No {showArchived ? "archived " : ""}
            courses.
          </div>
        ) : (
          /* ===============================================
             COURSE GRID
          =============================================== */

          <div
            className="
              grid
              grid-cols-1
              gap-6
              lg:grid-cols-2
              2xl:grid-cols-3
            "
          >
            {filtered.map((course) => {
              const mode =
                (course as any).deliveryMode?.toLowerCase() ||
                ((course as any).isOnline ? "online" : "physical");

              const menuOpen = openMenuId === course.id;

              return (
                /* =======================================
                     COURSE CARD
                  ======================================= */

                <article
                  key={course.id}
                  className="
                      relative
                      flex
                      min-w-0
                      flex-col
                      rounded-[16px]
                      border
                      border-slate-200
                      bg-white
                      p-6
                      shadow-[0_2px_8px_rgba(15,23,42,0.07)]
                      transition-shadow
                      hover:shadow-[0_4px_14px_rgba(15,23,42,0.09)]
                    "
                >
                  {/* =====================================
                        CARD HEADER
                    ===================================== */}

                  <header
                    className="
                        relative
                        flex
                        items-start
                        justify-between
                        gap-4
                      "
                  >
                    <div
                      className="
                          min-w-0 flex-1
                        "
                    >
                      <h2
                        className="
                            m-0
                            truncate
                            text-[18px]
                            font-bold
                            leading-6
                            tracking-[-0.015em]
                            text-slate-950
                          "
                        title={course.name}
                      >
                        {course.name}
                      </h2>

                      <p
                        className="
                            mb-0
                            mt-1
                            min-h-[24px]
                            truncate
                            text-[15px]
                            leading-6
                            text-slate-500
                          "
                        title={course.description || "—"}
                      >
                        {course.description || "—"}
                      </p>
                    </div>

                    <div
                      className="
                          flex
                          shrink-0
                          items-center
                          gap-2
                        "
                    >
                      <DeliveryBadge mode={mode} />

                      {/* Three-dot menu */}

                      {!showArchived && canModify && (
                        <div
                          className="relative"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <button
                            type="button"
                            aria-label="Course actions"
                            aria-expanded={menuOpen}
                            onClick={(e) => {
                              e.stopPropagation();

                              setOpenMenuId((prev) =>
                                prev === course.id ? null : course.id,
                              );
                            }}
                            className="
                                  grid
                                  h-8 w-8
                                  place-items-center
                                  rounded-lg
                                  border-0
                                  bg-transparent
                                  p-0
                                  text-slate-950
                                  transition
                                  hover:bg-slate-100
                                "
                          >
                            <IconMore />
                          </button>

                          {/* ===========================
                                  OVERFLOW MENU
                              =========================== */}

                          {menuOpen && (
                            <div
                              className="
                                    absolute
                                    right-0
                                    top-[38px]
                                    z-40
                                    w-[240px]
                                    overflow-hidden
                                    rounded-xl
                                    border
                                    border-slate-200
                                    bg-white
                                    py-1.5
                                    shadow-[0_10px_30px_rgba(15,23,42,0.14)]
                                  "
                            >
                              {/* Sync Drive */}

                              {course.driveFolderId && (
                                <button
                                  type="button"
                                  disabled={syncLoading === course.id}
                                  onClick={() => {
                                    setOpenMenuId(null);

                                    handleSyncDrive(
                                      course.id,
                                      course.driveFolderId!,
                                    );
                                  }}
                                  className="
                                        flex
                                        w-full
                                        items-center
                                        gap-3
                                        border-0
                                        bg-white
                                        px-4
                                        py-3
                                        text-left
                                        text-[15px]
                                        font-medium
                                        text-slate-900
                                        transition
                                        hover:bg-slate-50
                                        disabled:opacity-50
                                      "
                                >
                                  {syncLoading === course.id ? (
                                    <Spinner />
                                  ) : (
                                    <IconSync />
                                  )}
                                  Sync Drive
                                </button>
                              )}

                              {/* Start migration */}

                              {course.driveFolderId &&
                                !course.isMigratedToGroup &&
                                course.groupMigrationStatus !== "migrating" && (
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setOpenMenuId(null);

                                      handleMigrateOpen(course);
                                    }}
                                    className="
                                          flex
                                          w-full
                                          items-center
                                          gap-3
                                          border-0
                                          bg-white
                                          px-4
                                          py-3
                                          text-left
                                          text-[15px]
                                          font-medium
                                          text-slate-900
                                          transition
                                          hover:bg-slate-50
                                        "
                                  >
                                    <IconUsers />
                                    Migrate to Group
                                  </button>
                                )}

                              {/* Migration is running */}

                              {course.groupMigrationStatus === "migrating" && (
                                <>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setOpenMenuId(null);

                                      openLogModal(course);
                                    }}
                                    className="
                                          flex
                                          w-full
                                          items-center
                                          gap-3
                                          border-0
                                          bg-white
                                          px-4
                                          py-3
                                          text-left
                                          text-[15px]
                                          font-medium
                                          text-blue-700
                                          transition
                                          hover:bg-blue-50
                                        "
                                  >
                                    <Spinner />
                                    View Progress
                                  </button>

                                  <button
                                    type="button"
                                    onClick={() => {
                                      setOpenMenuId(null);

                                      handleMigrateOpen(course);
                                    }}
                                    className="
                                          flex
                                          w-full
                                          items-center
                                          gap-3
                                          border-0
                                          bg-white
                                          px-4
                                          py-3
                                          text-left
                                          text-[15px]
                                          font-medium
                                          text-slate-900
                                          transition
                                          hover:bg-slate-50
                                        "
                                  >
                                    <IconUsers />
                                    Re-run Migration
                                  </button>
                                </>
                              )}

                              {/* Completed / failed log */}

                              {(course.groupMigrationStatus === "completed" ||
                                course.groupMigrationStatus === "failed") &&
                                course.driveGroupEmail && (
                                  <>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setOpenMenuId(null);

                                        openLogModal(course);
                                      }}
                                      className="
                                            flex
                                            w-full
                                            items-center
                                            gap-3
                                            border-0
                                            bg-white
                                            px-4
                                            py-3
                                            text-left
                                            text-[15px]
                                            font-medium
                                            text-slate-900
                                            transition
                                            hover:bg-slate-50
                                          "
                                    >
                                      <IconBook />
                                      View Migration Log
                                    </button>

                                    <button
                                      type="button"
                                      onClick={() => {
                                        setOpenMenuId(null);

                                        handleMigrateOpen(course);
                                      }}
                                      className="
                                            flex
                                            w-full
                                            items-center
                                            gap-3
                                            border-0
                                            bg-white
                                            px-4
                                            py-3
                                            text-left
                                            text-[15px]
                                            font-medium
                                            text-slate-900
                                            transition
                                            hover:bg-slate-50
                                          "
                                    >
                                      <IconUsers />
                                      Re-migrate
                                    </button>
                                  </>
                                )}

                              {/* Failed retry */}

                              {course.groupMigrationStatus === "failed" && (
                                <button
                                  type="button"
                                  onClick={() => {
                                    setOpenMenuId(null);

                                    handleMigrateOpen(course);
                                  }}
                                  className="
                                        flex
                                        w-full
                                        items-center
                                        gap-3
                                        border-0
                                        bg-white
                                        px-4
                                        py-3
                                        text-left
                                        text-[15px]
                                        font-medium
                                        text-amber-700
                                        transition
                                        hover:bg-amber-50
                                      "
                                >
                                  <IconSync />
                                  Retry Migration
                                </button>
                              )}

                              {/* Divider */}

                              <div
                                className="
                                      my-1
                                      h-px
                                      bg-slate-100
                                    "
                              />

                              {/* Archive */}

                              <button
                                type="button"
                                onClick={() => {
                                  setOpenMenuId(null);

                                  handleArchive(course.id);
                                }}
                                className="
                                      flex
                                      w-full
                                      items-center
                                      gap-3
                                      border-0
                                      bg-white
                                      px-4
                                      py-3
                                      text-left
                                      text-[15px]
                                      font-medium
                                      text-red-600
                                      transition
                                      hover:bg-red-50
                                    "
                              >
                                <IconTrash />
                                Move to Recycle Bin
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </header>

                  {/* =====================================
                        DETAILS 2 X 2
                    ===================================== */}

                  <div
                    className="
                        mt-4
                        grid
                        grid-cols-2
                        gap-2.5
                      "
                  >
                    <div
                      className="
                          min-w-0
                          rounded-xl
                          bg-[#f1f4f8]
                          px-3.5
                          py-3
                        "
                    >
                      <div
                        className="
                            text-[11px]
                            font-medium
                            uppercase
                            tracking-[0.015em]
                            text-[#496383]
                          "
                      >
                        Base Fee
                      </div>

                      <div
                        className="
                            mt-1
                            text-[16px]
                            font-bold
                            leading-5
                            text-slate-950
                          "
                      >
                        ₹{Number(course.baseFee).toLocaleString("en-IN")}
                      </div>
                    </div>

                    <div
                      className="
                          min-w-0
                          rounded-xl
                          bg-[#f1f4f8]
                          px-3.5
                          py-3
                        "
                    >
                      <div
                        className="
                            text-[11px]
                            font-medium
                            uppercase
                            tracking-[0.015em]
                            text-[#496383]
                          "
                      >
                        Period
                      </div>

                      <div
                        className="
                            mt-1
                            text-[16px]
                            font-bold
                            leading-5
                            text-slate-950
                          "
                      >
                        {course.periodMonths}{" "}
                        {Number(course.periodMonths) === 1 ? "day" : "days"}
                      </div>
                    </div>

                    <div
                      className="
                          min-w-0
                          rounded-xl
                          bg-[#f1f4f8]
                          px-3.5
                          py-3
                        "
                    >
                      <div
                        className="
                            text-[11px]
                            font-medium
                            uppercase
                            tracking-[0.015em]
                            text-[#496383]
                          "
                      >
                        Material Access
                      </div>

                      <div
                        className="
                            mt-1
                            text-[16px]
                            font-bold
                            leading-5
                            text-slate-950
                          "
                      >
                        {course.materialAccessPeriod}{" "}
                        {accessUnitLabel(course.materialAccessPeriod)}
                      </div>
                    </div>

                    <div
                      className="
                          min-w-0
                          rounded-xl
                          bg-[#f1f4f8]
                          px-3.5
                          py-3
                        "
                    >
                      <div
                        className="
                            text-[11px]
                            font-medium
                            uppercase
                            leading-[14px]
                            tracking-[0.015em]
                            text-[#496383]
                          "
                      >
                        Max Viewer Discount
                      </div>

                      <div
                        className="
                            mt-1
                            text-[16px]
                            font-bold
                            leading-5
                            text-slate-950
                          "
                      >
                        ₹
                        {Number(course.maxViewerDiscount || 0).toLocaleString(
                          "en-IN",
                        )}
                      </div>
                    </div>
                  </div>

                  {/* =====================================
                        TELEGRAM
                    ===================================== */}

                  <div
                    className="
                        mt-5
                        flex
                        min-w-0
                        items-center
                        justify-between
                        gap-4
                        border-t
                        border-slate-200
                        pt-4
                      "
                  >
                    <span
                      className="
                          shrink-0
                          text-[13px]
                          text-[#516b8a]
                        "
                    >
                      Telegram server ID
                    </span>

                    <span
                      className="
                          min-w-0
                          truncate
                          text-right
                          text-[13px]
                          font-medium
                          text-slate-950
                        "
                      title={course.telegramServerId || "—"}
                    >
                      {course.telegramServerId || "—"}
                    </span>
                  </div>

                  {/* =====================================
                        DRIVE FOLDER
                    ===================================== */}

                  {(course as any).driveFolderUrl && (
                    <div
                      className="
                          mt-3
                          flex
                          min-w-0
                          items-center
                          justify-between
                          gap-4
                        "
                    >
                      <span
                        className="
                            shrink-0
                            text-[13px]
                            text-[#516b8a]
                          "
                      >
                        Google Drive
                      </span>

                      <a
                        href={(course as any).driveFolderUrl}
                        target="_blank"
                        rel="noreferrer"
                        className="
                            truncate
                            text-[13px]
                            font-medium
                            text-blue-600
                            no-underline
                            hover:underline
                          "
                      >
                        Open folder
                      </a>
                    </div>
                  )}

                  {/* =====================================
                        DRIVE GROUP
                    ===================================== */}

                  {course.driveGroupEmail && (
                    <div
                      className="
                          mt-3
                          flex
                          min-w-0
                          items-center
                          justify-between
                          gap-3
                        "
                    >
                      <span
                        className="
                            shrink-0
                            text-[13px]
                            text-[#516b8a]
                          "
                      >
                        Access Group
                      </span>

                      <div
                        className="
                            flex
                            min-w-0
                            items-center
                            justify-end
                            gap-2
                          "
                      >
                        <GroupStatusBadge
                          status={course.groupMigrationStatus}
                        />

                        <span
                          className="
                              max-w-[150px]
                              truncate
                              text-[12px]
                              font-medium
                              text-slate-700
                            "
                          title={course.driveGroupEmail}
                        >
                          {course.driveGroupEmail}
                        </span>
                      </div>
                    </div>
                  )}

                  {/* =====================================
                        CARD ACTIONS
                    ===================================== */}

                  <div
                    className="
                        mt-auto
                        pt-5
                      "
                  >
                    {canModify && !showArchived ? (
                      <>
                        {/* Main edit button */}

                        <button
                          type="button"
                          onClick={() => setEditTarget(course)}
                          className="
                              flex
                              h-[46px]
                              w-full
                              items-center
                              justify-center
                              gap-3
                              rounded-[10px]
                              border-0
                              bg-[#0d162a]
                              px-4
                              text-[15px]
                              font-semibold
                              text-white
                              shadow-sm
                              transition
                              hover:bg-[#172239]
                            "
                        >
                          <IconEdit />
                          Edit course
                        </button>

                        {/* Secondary buttons */}

                        <div
                          className="
                              mt-2.5
                              grid
                              grid-cols-3
                              gap-2
                            "
                        >
                          <button
                            type="button"
                            title="Mobile Delivery"
                            onClick={() =>
                              navigate(`/courses/${course.id}/mobile-delivery`)
                            }
                            className="
                                flex
                                h-10
                                min-w-0
                                items-center
                                justify-center
                                gap-2
                                overflow-hidden
                                rounded-[9px]
                                border
                                border-slate-200
                                bg-white
                                px-2
                                text-[13px]
                                font-medium
                                text-slate-950
                                shadow-[0_1px_3px_rgba(15,23,42,0.12)]
                                transition
                                hover:bg-slate-50
                              "
                          >
                            <span
                              className="
                                  shrink-0
                                "
                            >
                              <IconPhone />
                            </span>

                            <span
                              className="
                                  truncate
                                "
                            >
                              Mobile Delivery
                            </span>
                          </button>

                          <button
                            type="button"
                            title="Material Sync"
                            onClick={() => setMaterialSyncTarget(course)}
                            className="
                                flex
                                h-10
                                min-w-0
                                items-center
                                justify-center
                                gap-2
                                overflow-hidden
                                rounded-[9px]
                                border
                                border-slate-200
                                bg-white
                                px-2
                                text-[13px]
                                font-medium
                                text-slate-950
                                shadow-[0_1px_3px_rgba(15,23,42,0.12)]
                                transition
                                hover:bg-slate-50
                              "
                          >
                            <span
                              className="
                                  shrink-0
                                "
                            >
                              <IconFolder />
                            </span>

                            <span
                              className="
                                  truncate
                                "
                            >
                              Material Sync
                            </span>
                          </button>

                          <button
                            type="button"
                            title="Offline Downloads"
                            onClick={() =>
                              navigate(
                                `/courses/${course.id}/offline-downloads`,
                              )
                            }
                            className="
                                flex
                                h-10
                                min-w-0
                                items-center
                                justify-center
                                gap-2
                                overflow-hidden
                                rounded-[9px]
                                border
                                border-slate-200
                                bg-white
                                px-2
                                text-[13px]
                                font-medium
                                text-slate-950
                                shadow-[0_1px_3px_rgba(15,23,42,0.12)]
                                transition
                                hover:bg-slate-50
                              "
                          >
                            <span
                              className="
                                  shrink-0
                                "
                            >
                              <IconDownload />
                            </span>

                            <span
                              className="
                                  truncate
                                "
                            >
                              Downloads
                            </span>
                          </button>
                        </div>
                      </>
                    ) : canModify && showArchived ? (
                      <button
                        type="button"
                        onClick={() => handleUnarchive(course.id)}
                        className="
                            flex
                            h-[44px]
                            w-full
                            items-center
                            justify-center
                            rounded-[10px]
                            border-0
                            bg-[#0d162a]
                            px-4
                            text-sm
                            font-semibold
                            text-white
                            transition
                            hover:bg-[#172239]
                          "
                      >
                        Restore course
                      </button>
                    ) : null}
                  </div>
                </article>
              );
            })}
          </div>
        )}

        {/* =================================================
            CREATE FORM
        ================================================= */}

        {!showArchived && showCreate && (
          <CourseForm
            onSubmit={handleCreate}
            onCancel={() => setShowCreate(false)}
          />
        )}

        {/* =================================================
            EDIT FORM
        ================================================= */}

        {!!editTarget && (
          <EditCourseForm
            course={editTarget}
            onSubmit={handleUpdate}
            onCancel={() => setEditTarget(null)}
          />
        )}

        {/* =================================================
            MIGRATION LOG MODAL
        ================================================= */}

        {!!logTarget &&
          (() => {
            const stats = logTarget.groupMigrationStats;

            const total = stats?.total ?? 0;

            const migrated = stats?.migrated ?? 0;

            const failed = stats?.failed ?? 0;

            const pending = total - migrated - failed;

            const percentage =
              total > 0 ? Math.round((migrated / total) * 100) : 0;

            const isLive = logTarget.groupMigrationStatus === "migrating";

            return (
              <div
                className="
                  fixed inset-0
                  z-[1000]
                  grid
                  place-items-center
                  bg-slate-950/45
                  p-4
                "
                onClick={closeLogModal}
              >
                <div
                  className="
                    flex
                    w-full
                    max-w-[560px]
                    flex-col
                    gap-4
                    rounded-2xl
                    border
                    border-slate-200
                    bg-white
                    p-6
                    shadow-[0_24px_70px_rgba(15,23,42,0.24)]
                  "
                  onClick={(e) => e.stopPropagation()}
                >
                  <div
                    className="
                      flex
                      items-center
                      justify-between
                      gap-3
                    "
                  >
                    <h2
                      className="
                        m-0
                        text-xl
                        font-bold
                        text-slate-950
                      "
                    >
                      Migration Log
                    </h2>

                    <GroupStatusBadge status={logTarget.groupMigrationStatus} />
                  </div>

                  <p
                    className="
                      m-0
                      text-sm
                      leading-6
                      text-slate-600
                    "
                  >
                    <strong
                      className="
                        text-slate-900
                      "
                    >
                      {logTarget.name}
                    </strong>
                    <br />
                    Group:{" "}
                    <code
                      className="
                        rounded-md
                        bg-slate-100
                        px-1.5 py-0.5
                        text-[13px]
                        text-slate-800
                      "
                    >
                      {logTarget.driveGroupEmail}
                    </code>
                  </p>

                  {total > 0 && (
                    <div>
                      <div
                        className="
                          h-2.5
                          overflow-hidden
                          rounded-full
                          bg-slate-200
                        "
                      >
                        <div
                          className="
                            h-full
                            rounded-full
                            bg-slate-800
                            transition-[width]
                            duration-300
                          "
                          style={{
                            width: `${percentage}%`,
                          }}
                        />
                      </div>

                      <div
                        className="
                          mt-2
                          text-[13px]
                          font-medium
                          text-slate-600
                        "
                      >
                        {migrated} / {total} students ({percentage}
                        %)
                      </div>
                    </div>
                  )}

                  <div
                    className="
                      grid
                      grid-cols-2
                      gap-2
                      sm:grid-cols-4
                    "
                  >
                    <div
                      className="
                        rounded-xl
                        border
                        border-slate-200
                        bg-slate-50
                        p-3
                        text-center
                      "
                    >
                      <div
                        className="
                          text-xl
                          font-bold
                          text-emerald-600
                        "
                      >
                        {migrated}
                      </div>

                      <div
                        className="
                          mt-1
                          text-[10px]
                          font-medium
                          uppercase
                          tracking-wide
                          text-slate-500
                        "
                      >
                        Migrated
                      </div>
                    </div>

                    <div
                      className="
                        rounded-xl
                        border
                        border-slate-200
                        bg-slate-50
                        p-3
                        text-center
                      "
                    >
                      <div
                        className="
                          text-xl
                          font-bold
                          text-red-600
                        "
                      >
                        {failed}
                      </div>

                      <div
                        className="
                          mt-1
                          text-[10px]
                          font-medium
                          uppercase
                          tracking-wide
                          text-slate-500
                        "
                      >
                        Failed
                      </div>
                    </div>

                    <div
                      className="
                        rounded-xl
                        border
                        border-slate-200
                        bg-slate-50
                        p-3
                        text-center
                      "
                    >
                      <div
                        className="
                          text-xl
                          font-bold
                          text-slate-900
                        "
                      >
                        {pending}
                      </div>

                      <div
                        className="
                          mt-1
                          text-[10px]
                          font-medium
                          uppercase
                          tracking-wide
                          text-slate-500
                        "
                      >
                        Pending
                      </div>
                    </div>

                    <div
                      className="
                        rounded-xl
                        border
                        border-slate-200
                        bg-slate-50
                        p-3
                        text-center
                      "
                    >
                      <div
                        className="
                          text-xl
                          font-bold
                          text-slate-900
                        "
                      >
                        {total}
                      </div>

                      <div
                        className="
                          mt-1
                          text-[10px]
                          font-medium
                          uppercase
                          tracking-wide
                          text-slate-500
                        "
                      >
                        Total
                      </div>
                    </div>
                  </div>

                  <div
                    className="
                      flex
                      flex-col
                      gap-1
                      text-xs
                      text-slate-500
                    "
                  >
                    {stats?.startedAt && (
                      <span>
                        Started: {new Date(stats.startedAt).toLocaleString()}
                      </span>
                    )}

                    {stats?.completedAt && (
                      <span>
                        Completed:{" "}
                        {new Date(stats.completedAt).toLocaleString()}
                      </span>
                    )}

                    {isLive && (
                      <span
                        className="
                          flex
                          items-center
                          gap-2
                          font-medium
                          text-blue-600
                        "
                      >
                        <Spinner />
                        Live — refreshing every 3 seconds
                      </span>
                    )}
                  </div>

                  {(stats?.failedEmails?.length ?? 0) > 0 && (
                    <div
                      className="
                        rounded-xl
                        border
                        border-red-200
                        bg-red-50
                        p-3
                      "
                    >
                      <div
                        className="
                          mb-2
                          text-[13px]
                          font-semibold
                          text-red-700
                        "
                      >
                        Failed emails
                      </div>

                      <ul
                        className="
                          m-0
                          max-h-36
                          overflow-y-auto
                          pl-5
                          text-[13px]
                          text-red-700
                        "
                      >
                        {stats!.failedEmails.map((email) => (
                          <li key={email}>{email}</li>
                        ))}
                      </ul>
                    </div>
                  )}

                  <div
                    className="
                      flex
                      justify-end
                    "
                  >
                    <button
                      type="button"
                      onClick={closeLogModal}
                      className="
                        h-10
                        rounded-lg
                        border
                        border-slate-200
                        bg-white
                        px-4
                        text-sm
                        font-semibold
                        text-slate-700
                        transition
                        hover:bg-slate-50
                      "
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            );
          })()}

        {/* =================================================
            MIGRATE TO GROUP MODAL
        ================================================= */}

        {materialSyncTarget && (
          <CourseMaterialSyncDialog
            courseId={materialSyncTarget.id}
            courseName={materialSyncTarget.name}
            driveFolderId={materialSyncTarget.driveFolderId!}
            mobileEnabled={["hybrid", "mobile_app"].includes(
              materialSyncTarget.contentDeliveryMode,
            )}
            onClose={() => setMaterialSyncTarget(null)}
          />
        )}

        {bulkMaterialSyncCourses && (
          <BulkCourseMaterialSyncDialog
            courses={bulkMaterialSyncCourses}
            onClose={() => setBulkMaterialSyncCourses(null)}
          />
        )}

        {!!migrateTarget && (
          <div
            className="
              fixed inset-0
              z-[1000]
              grid
              place-items-center
              bg-slate-950/45
              p-4
            "
          >
            <div
              className="
                flex
                w-full
                max-w-[480px]
                flex-col
                gap-5
                rounded-2xl
                border
                border-slate-200
                bg-white
                p-6
                shadow-[0_24px_70px_rgba(15,23,42,0.24)]
              "
            >
              <div>
                <h2
                  className="
                    m-0
                    text-xl
                    font-bold
                    text-slate-950
                  "
                >
                  Migrate to Google Group
                </h2>

                <p
                  className="
                    mb-0
                    mt-2
                    text-sm
                    leading-6
                    text-slate-600
                  "
                >
                  Course:{" "}
                  <strong
                    className="
                      text-slate-900
                    "
                  >
                    {migrateTarget.name}
                  </strong>
                  <br />
                  All students currently sharing the Drive folder will be moved
                  to a Google Group. Existing access is uninterrupted — students
                  won't notice the switch.
                </p>
              </div>

              <label
                className="
                  flex
                  flex-col
                  gap-2
                  text-sm
                  font-semibold
                  text-slate-700
                "
              >
                <span>
                  Group Email{" "}
                  <span
                    className="
                      text-red-600
                    "
                  >
                    *
                  </span>
                </span>

                <input
                  type="email"
                  value={migrateGroupEmail}
                  onChange={(e) => setMigrateGroupEmail(e.target.value)}
                  placeholder="e.g. physics-2024@yourdomain.com"
                  autoFocus
                  className="
                    box-border
                    h-11
                    w-full
                    rounded-xl
                    border
                    border-slate-200
                    bg-white
                    px-3
                    text-sm
                    font-normal
                    text-slate-900
                    outline-none
                    transition
                    placeholder:text-slate-400
                    focus:border-slate-400
                    focus:ring-2
                    focus:ring-slate-100
                  "
                />

                <span
                  className="
                    text-xs
                    font-normal
                    leading-5
                    text-slate-500
                  "
                >
                  Must be a valid Google Workspace group email on your domain.
                </span>
              </label>

              <label
                className="
                  flex
                  flex-col
                  gap-2
                  text-sm
                  font-semibold
                  text-slate-700
                "
              >
                <span>
                  Group Name{" "}
                  <span
                    className="
                      font-normal
                      text-slate-400
                    "
                  >
                    (optional)
                  </span>
                </span>

                <input
                  type="text"
                  value={migrateGroupName}
                  onChange={(e) => setMigrateGroupName(e.target.value)}
                  placeholder="Display name for the group"
                  className="
                    box-border
                    h-11
                    w-full
                    rounded-xl
                    border
                    border-slate-200
                    bg-white
                    px-3
                    text-sm
                    font-normal
                    text-slate-900
                    outline-none
                    transition
                    placeholder:text-slate-400
                    focus:border-slate-400
                    focus:ring-2
                    focus:ring-slate-100
                  "
                />
              </label>

              <div
                className="
                  flex
                  justify-end
                  gap-2
                "
              >
                <button
                  type="button"
                  onClick={() => setMigrateTarget(null)}
                  disabled={migrateLoading}
                  className="
                    h-10
                    rounded-lg
                    border
                    border-slate-200
                    bg-white
                    px-4
                    text-sm
                    font-semibold
                    text-slate-700
                    transition
                    hover:bg-slate-50
                    disabled:opacity-50
                  "
                >
                  Cancel
                </button>

                <button
                  type="button"
                  onClick={handleMigrateSubmit}
                  disabled={migrateLoading || !migrateGroupEmail.trim()}
                  className="
                    inline-flex
                    h-10
                    items-center
                    justify-center
                    gap-2
                    rounded-lg
                    border-0
                    bg-slate-950
                    px-4
                    text-sm
                    font-semibold
                    text-white
                    transition
                    hover:bg-slate-800
                    disabled:cursor-not-allowed
                    disabled:opacity-50
                  "
                >
                  {migrateLoading && <Spinner dark />}

                  {migrateLoading ? "Starting…" : "Migrate"}
                </button>
              </div>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}
